<div class="outer">
    <div *ngIf="showMessage == 1" class="section">{{ 265 | l : lang.ph }}</div>
    <div *ngIf="showMessage == 2" class="section">{{ 322 | l : lang.ph }}</div>
</div>